import axios from "axios";
import Cookies from "js-cookie";
import { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const [user, setUser] = useState(() => {
    const cookieUser = Cookies.get("user");
    return cookieUser ? JSON.parse(cookieUser) : null;
  });
  const [token, setToken] = useState(() => Cookies.get("token") || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (input) => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(
        "https://final-project-api-alpha.vercel.app/api/auth/login",
        input
      );
      const { token, user } = res.data;
      setUser(user);
      setToken(token);
      Cookies.set("token", token, { expires: 1, path: "/" });
      Cookies.set("user", JSON.stringify(user), { expires: 1, path: "/" });
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.message || "Email atau password salah");
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (input) => {
    setLoading(true);
    setError("");
    try {
      await axios.post(
        "https://final-project-api-alpha.vercel.app/api/auth/register",
        input
      );
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.message || "Gagal mendaftar, coba lagi");
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async (
    currentPassword,
    newPassword,
    confirmPassword
  ) => {
    setLoading(true);
    setError("");
    try {
      if (!token) throw new Error("Token tidak ditemukan");

      if (newPassword !== confirmPassword) {
        throw new Error("Password baru dan konfirmasi tidak sama");
      }

      await axios.post(
        "https://dev-example.sanbercloud.com/api/change-password",
        {
          current_password: currentPassword,
          new_password: newPassword,
          new_confirm_password: confirmPassword,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return true;
    } catch (err) {
      setError(
        err.response?.data?.message || err.message || "Gagal mengubah password"
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setUser(null);
    setToken(null);
    Cookies.remove("token");
    Cookies.remove("user");
    navigate("/login");
  };

  const states = {
    user,
    token,
    loading,
    error,
  };

  const actions = {
    handleLogin,
    handleRegister,
    handleChangePassword,
    handleLogout,
    setError,
  };

  return (
    <AuthContext.Provider value={{ states, actions }}>
      {children}
    </AuthContext.Provider>
  );
};
